import _codemirror from "../../lib/codemirror";
var _global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : global;
// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/5/LICENSE

(function (mod) {
  // CommonJS
  mod(_codemirror);
})(function (CodeMirror) {
  "use strict";

  function Bar(cls, orientation, scroll) {
    (this || _global).orientation = orientation;
    (this || _global).scroll = scroll;
    (this || _global).screen = (this || _global).total = (this || _global).size = 1;
    (this || _global).pos = 0;
    (this || _global).node = document.createElement("div");
    (this || _global).node.className = cls + "-" + orientation;
    (this || _global).inner = (this || _global).node.appendChild(document.createElement("div"));
    var self = this || _global;
    CodeMirror.on((this || _global).inner, "mousedown", function (e) {
      if (e.which != 1) return;
      CodeMirror.e_preventDefault(e);
      var axis = self.orientation == "horizontal" ? "pageX" : "pageY";
      var start = e[axis],
        startpos = self.pos;
      function done() {
        CodeMirror.off(document, "mousemove", move);
        CodeMirror.off(document, "mouseup", done);
      }
      function move(e) {
        if (e.which != 1) return done();
        self.moveTo(startpos + (e[axis] - start) * (self.total / self.size));
      }
      CodeMirror.on(document, "mousemove", move);
      CodeMirror.on(document, "mouseup", done);
    });
    CodeMirror.on((this || _global).node, "click", function (e) {
      CodeMirror.e_preventDefault(e);
      var innerBox = self.inner.getBoundingClientRect(),
        where;
      if (self.orientation == "horizontal") where = e.clientX < innerBox.left ? -1 : e.clientX > innerBox.right ? 1 : 0;else where = e.clientY < innerBox.top ? -1 : e.clientY > innerBox.bottom ? 1 : 0;
      self.moveTo(self.pos + where * self.screen);
    });
    function onWheel(e) {
      var moved = CodeMirror.wheelEventPixels(e)[self.orientation == "horizontal" ? "x" : "y"];
      var oldPos = self.pos;
      self.moveTo(self.pos + moved);
      if (self.pos != oldPos) CodeMirror.e_preventDefault(e);
    }
    CodeMirror.on((this || _global).node, "mousewheel", onWheel);
    CodeMirror.on((this || _global).node, "DOMMouseScroll", onWheel);
  }
  Bar.prototype.setPos = function (pos, force) {
    if (pos < 0) pos = 0;
    if (pos > (this || _global).total - (this || _global).screen) pos = (this || _global).total - (this || _global).screen;
    if (!force && pos == (this || _global).pos) return false;
    (this || _global).pos = pos;
    (this || _global).inner.style[(this || _global).orientation == "horizontal" ? "left" : "top"] = pos * ((this || _global).size / (this || _global).total) + "px";
    return true;
  };
  Bar.prototype.moveTo = function (pos) {
    if (this.setPos(pos)) this.scroll(pos, (this || _global).orientation);
  };
  var minButtonSize = 10;
  Bar.prototype.update = function (scrollSize, clientSize, barSize) {
    var sizeChanged = (this || _global).screen != clientSize || (this || _global).total != scrollSize || (this || _global).size != barSize;
    if (sizeChanged) {
      (this || _global).screen = clientSize;
      (this || _global).total = scrollSize;
      (this || _global).size = barSize;
    }
    var buttonSize = (this || _global).screen * ((this || _global).size / (this || _global).total);
    if (buttonSize < minButtonSize) {
      (this || _global).size -= minButtonSize - buttonSize;
      buttonSize = minButtonSize;
    }
    (this || _global).inner.style[(this || _global).orientation == "horizontal" ? "width" : "height"] = buttonSize + "px";
    this.setPos((this || _global).pos, sizeChanged);
  };
  function SimpleScrollbars(cls, place, scroll) {
    (this || _global).addClass = cls;
    (this || _global).horiz = new Bar(cls, "horizontal", scroll);
    place((this || _global).horiz.node);
    (this || _global).vert = new Bar(cls, "vertical", scroll);
    place((this || _global).vert.node);
    (this || _global).width = null;
  }
  SimpleScrollbars.prototype.update = function (measure) {
    if ((this || _global).width == null) {
      var style = window.getComputedStyle ? window.getComputedStyle((this || _global).horiz.node) : (this || _global).horiz.node.currentStyle;
      if (style) (this || _global).width = parseInt(style.height);
    }
    var width = (this || _global).width || 0;
    var needsH = measure.scrollWidth > measure.clientWidth + 1;
    var needsV = measure.scrollHeight > measure.clientHeight + 1;
    (this || _global).vert.node.style.display = needsV ? "block" : "none";
    (this || _global).horiz.node.style.display = needsH ? "block" : "none";
    if (needsV) {
      (this || _global).vert.update(measure.scrollHeight, measure.clientHeight, measure.viewHeight - (needsH ? width : 0));
      (this || _global).vert.node.style.bottom = needsH ? width + "px" : "0";
    }
    if (needsH) {
      (this || _global).horiz.update(measure.scrollWidth, measure.clientWidth, measure.viewWidth - (needsV ? width : 0) - measure.barLeft);
      (this || _global).horiz.node.style.right = needsV ? width + "px" : "0";
      (this || _global).horiz.node.style.left = measure.barLeft + "px";
    }
    return {
      right: needsV ? width : 0,
      bottom: needsH ? width : 0
    };
  };
  SimpleScrollbars.prototype.setScrollTop = function (pos) {
    (this || _global).vert.setPos(pos);
  };
  SimpleScrollbars.prototype.setScrollLeft = function (pos) {
    (this || _global).horiz.setPos(pos);
  };
  SimpleScrollbars.prototype.clear = function () {
    var parent = (this || _global).horiz.node.parentNode;
    parent.removeChild((this || _global).horiz.node);
    parent.removeChild((this || _global).vert.node);
  };
  CodeMirror.scrollbarModel.simple = function (place, scroll) {
    return new SimpleScrollbars("CodeMirror-simplescroll", place, scroll);
  };
  CodeMirror.scrollbarModel.overlay = function (place, scroll) {
    return new SimpleScrollbars("CodeMirror-overlayscroll", place, scroll);
  };
});
export default {};